import React, { useState } from "react";
import emailjs from "emailjs-com";
import "./ContactUs.css";

const ContactUs = () => {
  const initialFormData = {
    name: "",
    email: "",
    phone: "",
    message: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_hbaem1j",
        "template_z7a1555",
        formData,
        "y9eKfgkGl4aEPqgwJ"
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          alert("Message sent successfully!");
          setFormData(initialFormData);
        },
        (error) => {
          console.log("FAILED...", error);
          alert("Failed to send message, please try again.");
        }
      );
  };

  return (
    <div className="contact-us-wrapper " style={{ display: "grid" }}>
      <h1
        style={{
          textAlign: "center",
          marginBottom: "20px",
          position: "relative",
        }}
      >
        <span
          style={{
            borderBottom: "5px solid gold",
            padding: "3px",
            display: "inline-block",
          }}
        >
          Contact Us
        </span>
      </h1>
      <div className="contact-us-container">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="formName">Name</label>
            <input
              type="text"
              id="formName"
              name="name"
              placeholder="Enter your name"
              value={formData.name}
              onChange={handleChange}
              autoComplete="off"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="formEmail">Email address</label>
            <input
              type="email"
              id="formEmail"
              name="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              autoComplete="off"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="formPhone">Phone Number</label>
            <input
              type="tel"
              id="formPhone"
              name="phone"
              placeholder="Enter your phone number"
              value={formData.phone}
              onChange={handleChange}
              autoComplete="off"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="formMessage">Message</label>
            <textarea
              id="formMessage"
              name="message"
              rows="4"
              placeholder="Enter your message"
              value={formData.message}
              onChange={handleChange}
              autoComplete="off"
              required
            ></textarea>
          </div>

          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default ContactUs;
